import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ChartistGraph from 'react-chartist';
import Chartist from 'chartist';
import moment from 'moment';
// @material-ui/core components
import withStyles from '@material-ui/core/styles/withStyles';
// core components
import Card from 'components/UI/Card/Card';
import CardHeader from 'components/UI/Card/CardHeader';
import CardBody from 'components/UI/Card/CardBody';
// our components
import MetricsFooter from 'components/common/MetricsFooter';
// styles
import DashboardStyles from 'assets/jss/material-dashboard-pro-react/views/dashboardStyle';

class Metrics extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      format: 'dddd',
    };
  }

  /**
   * @description
   * to change format to Moment
   * @param {string} date - Date string shape.
   * @returns {*} - Format shape for Moment.
   */
  handleChangedDate = date => {
    const { statsUpdate } = this.props;
    let minDateTime = null;
    const maxDateTime = moment();
    if (date === 'last_month') {
      minDateTime = moment().subtract(1, 'month');
      this.setState({ format: 'D' });
    } else {
      minDateTime = moment().subtract(1, 'week');
      this.setState({ format: 'dddd' });
    }
    statsUpdate({ minDateTime, maxDateTime });
  };

  render() {
    const { classes, data, color, type, title } = this.props;
    const { format } = this.state;
    const labels = [];
    const series = [];
    data.forEach(item => {
      labels.push(moment(item.date).format(format));
      series.push(item.value);
    });
    const maxValue = Math.max(...series);
    return (
      <Card chart>
        <CardHeader color={color}>
          <ChartistGraph
            className="ct-chart-white-colors"
            data={maxValue > 0 ? { labels, series: [[...series]] } : {}}
            type={type}
            options={{
              lineSmooth: Chartist.Interpolation.cardinal({
                tension: 0,
              }),
              axisX: {
                showGrid: false,
              },
              low: 0,
              high: maxValue,
              chartPadding: {
                top: 0,
                right: 5,
                bottom: 0,
                left: 0,
              },
            }}
            responsiveOptions={[
              [
                'screen and (max-width: 640px)',
                {
                  seriesBarDistance: 5,
                  axisX: {
                    labelInterpolationFnc(value) {
                      return value[0];
                    },
                  },
                },
              ],
            ]}
            listener={{
              draw(info) {
                if (info.type === 'bar') {
                  info.element.animate({
                    opacity: {
                      begin: (info.index + 1) * 80,
                      dur: 500,
                      from: 0,
                      to: 1,
                      easing: 'ease',
                    },
                  });
                }
              },
            }}
          />
        </CardHeader>
        <CardBody className={classes.rowTitle}>
          <h6>{title}</h6>
        </CardBody>
        <MetricsFooter onUpdate={date => this.handleChangedDate(date)} />
      </Card>
    );
  }
}

/**
 * Metrics PropTypes
 * @param classes - prop styles received from withStyles
 * @param data - prop data received from parent
 * @param title - graph title
 * @param color - color of the icon container
 * @param type - type of graph that will be rendered
 * @callback statsUpdate - called when button Update or edited date is pressed.
 */

Metrics.propTypes = {
  classes: PropTypes.instanceOf(Object).isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  statsUpdate: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  color: PropTypes.string,
  type: PropTypes.oneOf(['Bar', 'Line']),
};

Metrics.defaultProps = {
  color: 'primary',
  type: 'Bar',
};

export default withStyles(DashboardStyles)(Metrics);
